<template>
  <div class="loader">
    <svgo-logo-icon
      class="loader__image"
      :style="{ width: `${iconWidth}px`, height: `${iconHeight}px` }"
    />
    <p
      v-if="text"
      class="loader__text"
      :style="{ fontSize: `${textSize}px` }"
      v-html="text"
    />
  </div>
</template>

<script setup>
defineProps({
  text: {
    type: String,
    default: null,
  },
  iconWidth: {
    type: [Number, String],
    default: 60,
  },
  iconHeight: {
    type: [Number, String],
    default: 60,
  },
  textSize: {
    type: [Number, String],
    default: 16,
  },
});
</script>

<style lang="scss">
@use '@/assets/styles/components/loader.scss' as *;
</style>
